export const MENU = [
  { key: "d2d", label: "D2D Collection, Segregation & Transport", num: "1" },
  {
    label: "Urban Visual Sanitation",
    num: "2",
    children: [
      { key: "uvs_residential", label: "Residential Area", num: "2.1" },
      { key: "uvs_public", label: "Public Area", num: "2.2" },
      { key: "uvs_water", label: "Water bodies / Storm water drain / Nallahs", num: "2.3" },
      { key: "uvs_walls", label: "Aesthetic walls and Surroundings", num: "2.4" },
    ],
  },
  {
    label: "Solid Waste Management",
    num: "3",
    children: [
      { key: "swm_wet", label: "Wet Waste Management", num: "3.1" },
      { key: "swm_dry", label: "Dry Waste Management", num: "3.2" },
      { key: "swm_hazardous", label: "Domestic Hazardous Waste", num: "3.3" },
      { key: "swm_cd", label: "C&D Waste Management", num: "3.4" },
      { key: "swm_bwg", label: "Bulk Waste Generators", num: "3.5" },
      { key: "swm_landfill", label: "Sanitary Landfill", num: "3.6" },
      { key: "swm_bioremediation", label: "Bio-Remediations of dumpsite", num: "3.7" },
    ],
  },
  { key: "sanitation", label: "Sanitation (ODF, CT/PT)", num: "4" },
  { key: "citizen_feedback", label: "Citizen Feedback", num: "5" },
];

// flat lookup of label by key
export const CATEGORY_LABELS = (() => {
  const map = {};
  const walk = (items) => items.forEach((i) => { if (i.key) map[i.key] = i.label; if (i.children) walk(i.children); });
  walk(MENU);
  return map;
})();
